import {
  TweenMax,
  Power2,
  TimelineMax,
} from 'gsap/TweenMax'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import $ from 'jquery'
import heroAnimation from './animations/hero'
import parallax from './animations/parallax'
import splitTitleAnimation from './animations/title'
import fadeAnimations from './animations/fade'
import electricity from './electricity'
import imageCarousel from './carousel'
import galleryMasking from './animations/gallerymasking'
import panelCarousel from './panelCarousel'
import Swiper from 'swiper/dist/js/swiper'
import draggableFloors from './draggableFloors'


// Need to reference GSAP plugins so that they will not be plucked away by Webpack tree shaking.
// Read more: https://greensock.com/docs/NPMUsage
// eslint-disable-next-line
const GSAP_PLUGINS = [ScrollToPlugin]

if (!$('body').hasClass('home')) {
  if ($('body').hasClass('page-template-default') || $('body').hasClass('archive') || $('body').hasClass('page-template-template-location')) {
    /* if ($('body').hasClass('home') && $('.split-text') && $('.c-hero__lines').length > 0) {
      TweenMax.to(window, 2, {
        scrollTo: {
          y: '.split-text',
          offsetY: 400,
        },
        ease: Power2.easeOut,
        delay: 4.5,
      })
    } else */
    if ($('.split-text') && !$('.c-hero__lines').length > 0) {
      TweenMax.to(window, 2, {
        scrollTo: {
          y: '.o-layout__body',
          offsetY: 400,
        },
        ease: Power2.easeOut,
        delay: 1,
      })
    } else if ($('.c-modular__module--carousel')) {
      TweenMax.to(window, 2, {
        scrollTo: {
          y: '.o-layout__body',
          offsetY: 400,
        },
        ease: Power2.easeOut,
        delay: 1,
      })
      if ($(window).width() > 768) {
        galleryMasking()
      }
    } else {
      TweenMax.to(window, 2, {
        scrollTo: {
          y: '.o-layout__body',
          offsetY: 400,
        },
        ease: Power2.easeOut,
        delay: 1,
      })
    }
  }
}

$('.c-body-copy').each(function () {
  const title = $('h2', $(this))
  if (title.length > 0) {
    title.addClass('split-text')

    if ($(window).width() > 767) {
      if ($('body').hasClass('home')) {
        setTimeout(() => {
          splitTitleAnimation(title)
        }, 4500)
      } else {
        setTimeout(() => {
          splitTitleAnimation(title)
        }, 1100)
      }
    } else {
      splitTitleAnimation(title)
    }
  }
})

const menutl = new TimelineMax({
  paused: true,
  reversed: true,
})

menutl
  .fromTo('.c-menu .o-layout__head-overlay--upper', 1, {
    y: -140,
    x: 0,
  }, {
    y: 0,
    x: 0,
  }, 1)
  .fromTo('.c-menu .o-layout__head-overlay--lower', 1, {
    y: 140,
    x: 0,
  }, {
    y: 0,
    x: 0,
  }, 1)
  .staggerFromTo('.menu-item', 0.6, {
    x: 20,
    opacity: 0,
  }, {
    x: 0,
    opacity: 1,
  }, 0.05)

$('[data-toggle]').on('click', function () {
  const target = $(this).attr('data-toggle')
  $(`#${target}`).fadeToggle(600)

  if (target === 'menu') {
    $(`#${target}`).toggleClass('is-open')

    $('.c-menu__overlay').toggleClass('c-menu__overlay--shown')

    const menuButtonClose = $('.c-close-menu').val()
    const menuButtonOpen = $('.c-open-menu').val()

    if ($('.c-menu').hasClass('is-open')) {
      $('.c-menu__button').html(menuButtonClose)
      menutl.play()
    } else {
      $('.c-menu__button').html(menuButtonOpen)
      menutl.progress(0)
    }
  }

  if (target === 'contact-modal') {
    $(`#${target}`).toggleClass('c-contact--open')
  }
})

$('[data-tooltip]').on('mouseover', function () {
  const target = $(this).attr('data-tooltip')
  if ($(`#${target}`).hasClass('shown')) {
    $(`#${target}`).removeClass('shown')
  } else {
    $(`#${target}`).addClass('shown')
  }
})

$('[data-tooltip]').on('mouseleave', function () {
  const target = $(this).attr('data-tooltip')
  $(`#${target}`).removeClass('shown')
})


/*
 * Gravity Forms focus/dirty class on parent li
 */

$.fn.labelOver = function (overClass) {
  return this.each(function () {
    const label = $(this)
    const f = label.attr('for')
    if (f) {
      const input = $(`#${f}`)

      this.hide = function () {
        label.closest('li').addClass('is-focused')
      }
      this.show = function () {
        if (input.val() === '') label.closest('li').removeClass('is-focused')
      }

      input.focus(this.hide)
      input.blur(this.show)
    }
  })
}

if ($('.gfield label').length > 0) {
  $('.gfield label').labelOver()
}

if ($('[data-parallax]').length > 0 && $(window).width() > 767) {
  parallax()
}

if ($('[data-carousel]').length > 0) {
  imageCarousel()
}

if ($('[data-panel]').length > 0) {
  panelCarousel()
}

if ($('.c-map-locations__tab').length > 0) {
  $('[data-location]').on('click', function (e) {
    e.preventDefault()
    const dest = $(this).data('location')

    if ($(window).width() >= 768) {
      $('.c-map-locations__pins.active-tab').removeClass('active-tab')
      $('.c-map-locations__tab.active-tab').removeClass('active-tab')
      $(this).parent().addClass('active-tab')
      $(`#${dest}`).addClass('active-tab')
    } else {
      $('.c-map-locations__point.active-tab').slideUp().removeClass('active-tab')
      $(`#${dest}`).slideDown().addClass('active-tab')
      $(this).toggleClass('active-tab')
    }
  })
}

if ($('.c-button--contact__animated').length > 0) {
  const animateLine = new TimelineMax({
    repeat: -1,
  })
  animateLine.to('.c-button--contact__animated', 1, {
    backgroundPosition: '-18px 0px',
    ease: Linear.easeNone,
  })
  animateLine.timeScale(0.75)
}

if ($('.c-electricity').length > 0) {
  electricity()
}

if ($('body').hasClass('home')) {
  heroAnimation()
}

if ($('body').hasClass('home') && $(window).width() > 767) {
  fadeAnimations()
}

if ($('.c-spaces').length > 0) {
  draggableFloors()
}

if ($('.c-button--animate').length > 0) {
  $('.c-button--animate').bind('webkitAnimationEnd mozAnimationEnd animationEnd', function () {
    $(this).removeClass('animated')
  })

  $('.c-button--animate').hover(function () {
    $(this).addClass('animated')
  })
}
